import React, { useState } from 'react';

import toast from 'react-hot-toast';
import axios from "axios";

import run from "../../../assets/RunOrScheduleAssets/run.png";
import schedule from "../../../assets/RunOrScheduleAssets/schedule.png";
import ActionCard from './ActionCard';
import ScheduleFrequency from './ScheduleFrequency';
import { API } from "../../../global";
import Success from '../../ReUseable/Success/Success';
import Loader from '../../ReUseable/Loader/Loader';

const RunOrSchedule = (props) => {
  const { clearStates, setShowRunOrSchedule, setDestinationStepper } = props;
  const [showScheduleOptions, setShowScheduleOptions] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleShowScheduleOptions = () => {
    setShowScheduleOptions(true);
  }

  const addMinutesToCurrentTime = (minutes) => {
    const currentDate = new Date();
    currentDate.setMinutes(currentDate.getMinutes() + minutes);

    const date = currentDate.toISOString();

    let hours = currentDate.getHours();
    const minutesVal = currentDate.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const time = `${hours}:${minutesVal} ${ampm}`;

    return { date, time };
  };

  const { date, time } = addMinutesToCurrentTime(5);

  const handleRun = async () => {
    setLoading(true);
    let scheduleDetails = {
      occurrence: "Once",
      date: date,
      time: time,
      pipelineId: localStorage.getItem("pipelineId")
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("auth_token")}`
      }
    };
    try {
      const res = await axios.post(`${API}/schedule-task/create`, scheduleDetails, config);
      if (res.data.success) {
        setIsSuccess(true);
        setDestinationStepper(true);
        setLoading(false);
      } else {
        toast.error(res.data.error.msg);
        setLoading(false);
      }
    } catch (error) {
      console.error('Error in API calls:', error);
      toast.error("Error in API calls");
      setLoading(false);
    }
  }

  const clearStatesUpdated = () => {
    clearStates();
    setShowRunOrSchedule(false);
  }

  return (
    <>
      {isSuccess ? (
        <Success
          clearStates={clearStatesUpdated}
          message="The task has been scheduled successfully."
        />
      ) : loading ? (
        <Loader />
      ) : showScheduleOptions ? (
        <ScheduleFrequency
          setShowScheduleOptions={setShowScheduleOptions}
          clearStates={clearStates}
          setShowRunOrSchedule={setShowRunOrSchedule}
          setDestinationStepper={setDestinationStepper}
        />
      ) : (
        <div className="flex justify-center space-x-8 mt-16">
          <ActionCard
            icon={run}
            title="Run Now"
            description={["Execute the process instantly", "with a single click."]}
            onClick={handleRun}
          />
          <ActionCard
            icon={schedule}
            title="Schedule"
            description={["Set a future date and time", "to run the process automatically."]}
            onClick={handleShowScheduleOptions}
          />
        </div>
      )}
    </>
  );
};

export default RunOrSchedule;